module.exports = __webpack_public_path__ + "static/media/loophq-icon.eefa53ab.svg";